module.exports = __webpack_public_path__ + "static/media/new-tab.894a75d6.svg";